import React from "react";
import KioskStartButton from "../components/start-button";
import QRCode from "react-qr-code";
import { motion } from "framer-motion";
import { calculateEstimate } from "lib/calculateEstimate";

export default function QrCodeScreen({
  navigate,
  weight,
  estimate,
  signedWeight,
}) {
  return (
    <div className="flex flex-col items-center justify-between w-full h-full relative">
      <div className="flex flex-col px-[3vh] relative z-10">
        <p className="text-[60px] text-black text-center mt-[2vh]">
          Your trade-in summary
        </p>

        <div className="flex justify-between pt-8">
          {/* Weight display */}
          <div className="flex flex-col mr-[80px] items-center">
            <div className="flex w-full justify-center">
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1"></div>
            </div>
            <div className="flex bg-blue items-baseline text-white w-[370px] justify-center">
              <div className="text-[90px]">{weight.toFixed(2)}</div>
              <div className="text-[50px] ml-[1vh]">lbs</div>
            </div>
            <div className="text-[24px] pt-4">Package weight</div>
          </div>

          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-[200px] h-[230px] mr-[80px]"
          >
            <div className="pb-1">
              <QRCode
                bgColor="transparent"
                value={JSON.stringify({
                  signedWeight: signedWeight,
                  weight: parseFloat(weight.toFixed(2)),
                  timestamp: Date.now(),
                  value: calculateEstimate(
                    weight.toFixed(2),
                    null,
                    [],
                    new Date().toISOString()
                  ).gift,
                  currency: "$",
                })}
                size={128}
                className="relative w-full h-full p-[14px]"
              />
              <p className="text-[14px] text-center">
                For Brick Specialist Use Only
              </p>
            </div>
          </motion.div>

          {/* Value estimate display */}
          <div className="flex flex-col items-center">
            <div className="flex w-full justify-center">
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1"></div>
            </div>
            <div className="flex bg-green text-white w-[370px] justify-center">
              <div className="text-[32px] mr-[0.8rem] mt-[1vh]">$</div>
              <div className="text-[90px]">{estimate.gift}</div>
            </div>
            <div className="text-[24px] pt-4">As a LEGO e-Gift Card</div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-[48px] px-[4vh] relative z-10 mb-[4vh]">
        <KioskStartButton
          onClick={() => navigate("weightDisplay")}
          icon="arrow_back"
        >
          Go Back
        </KioskStartButton>

        <KioskStartButton
          className="font-semibold"
          onClick={() => {
            navigate("holding");
          }}
          icon="check"
          iconColor="black"
          color="yellow"
        >
          Finish
        </KioskStartButton>
      </div>
    </div>
  );
}
